import "core-js/modules/es.json.stringify.js";
import { useRouter } from 'vue-router';
import { onMounted, nextTick, computed } from "vue";
import { useNewsStore } from "../../../store/news"; //引入news仓库

import { storeToRefs, mapS } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { WOW } from 'wowjs';
import "animate.css";
export default {
  name: "NewsTrands",
  setup: function setup() {
    var router = useRouter();
    var store = useNewsStore();
    onMounted(function () {
      //初始化wow.js(页面滚动加载动画)
      nextTick(function () {
        //页面渲染完，再执行
        var wow = new WOW({
          live: false
        });
        wow.init();
      });
      store.getNewsList(); //通知vuex发送请求获取新闻列表的数据
    });
    var homeNewsList = computed(function () {
      return store.homeNewsList;
    }); //获取仓库里getters计算后的 截取新闻列表前三条数据的列表
    //跳转到新闻动态

    function goNewsDetail(item) {
      router.push({
        path: "/news/newsdetails",
        query: {
          imgUrl: item.imgUrl,
          title: item.title,
          content: JSON.stringify(item.content),
          releaseDate: item.releaseDate
        }
      }); //将该函数包裹一个定时器确保可以获取跳转页面后的指定位置的id

      setTimeout(function () {
        var goDetailTop = document.getElementById('long-left');
        goDetailTop.scrollIntoView({
          behavior: 'smooth',
          //平滑滚动
          block: "center" //将指定位置滚动到页面中间

        });
      }, 100);
    }

    return {
      homeNewsList: homeNewsList,
      goNewsDetail: goNewsDetail
    };
  }
};